import { AxiosResponse } from "axios";
import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthFunctions } from "../utils/FrontendAuthFunctions";

export const ProtectedRoute = ({
  children,
  adminOnly = false,
}: {
  children: ReactNode;
  adminOnly?: boolean;
}) => {
  const navigate = useNavigate();
  const [authOk, setAuthOk] = useState(false);

  useEffect(() => {
    const onAuthSuccess = (resp: AxiosResponse) => {
      const isAdmin = resp?.data?.admin === true;
      if (adminOnly && !isAdmin) {
        navigate("/home");
        return;
      }
      setAuthOk(true);
    };

    const onAuthFail = () => {
      navigate("/login");
    };

    const onLoad = async () => {
      await AuthFunctions.auth(onAuthSuccess, onAuthFail);
    };
    onLoad();
  }, [adminOnly, navigate]);

  return authOk ? <>{children}</> : null;
};
